import { gql } from '@apollo/client';
export const createUploadedDocumentMutation = gql `
  mutation createUploadedDocument($document: FileSystemDocumentInsertInput!) {
    document: createFileSystemDocument(input: $document) {
      id
      parentId
      categoryId
      name
      date: updatedAt
      depth
      draftId
      marketCode
      signed
      type
      kind

      acl: acls {
        id
        userId
        actions
        user: user2 {
          id
          name
          email
        }
      }

      user: user2 {
        id
        name
        email
      }

      lastSignRequest {
        id
        status
      }
    }
  }
`;
